import React from "react"
import BlogPreviewAuthorStyle from "./BlogPreviewAuthorStyle.module.styl"
import Check from "../../../../../../../assets/images/check.png"
import Image from "gatsby-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClock } from "@fortawesome/free-regular-svg-icons/faClock"
import { faCalendarAlt } from "@fortawesome/free-regular-svg-icons/faCalendarAlt"

const BlogPreviewConfirmedDoctor = ({ doctor, timeToRead, date, author }) => {
  return (
    <div className={BlogPreviewAuthorStyle.holder}>
      <div className={BlogPreviewAuthorStyle.author_holder}>
        {doctor && doctor ? (
          <React.Fragment>
            <div className={BlogPreviewAuthorStyle.doctor_holder}>
            {" "}  <Image
            className={BlogPreviewAuthorStyle.image_holder}
            fluid={doctor.avatar.fluid}
          />
          <div>
            <p className={BlogPreviewAuthorStyle.author_name}>{doctor.name}</p>

            <p className={BlogPreviewAuthorStyle.confirmed}>
              <img alt="check" src={Check} />
              Потвърдено от лекар
            </p>
          </div>
            </div>
          </React.Fragment>
        ) : (
          <div className={BlogPreviewAuthorStyle.author_holder}>
            {" "}
            <Image
              className={BlogPreviewAuthorStyle.image_holder}
              fluid={author.avatar.fluid}
            />
            <p className={BlogPreviewAuthorStyle.author_name}>{author.name}</p>
          </div>
        )}
      </div>
      <div className={BlogPreviewAuthorStyle.date_holder}>
        <p>
          <FontAwesomeIcon icon={faClock} />
          {timeToRead} мин за четене
        </p>
        <p>
          {" "}
          <FontAwesomeIcon icon={faCalendarAlt} />
          {date}
        </p>
      </div>
    </div>
  )
}

export default BlogPreviewConfirmedDoctor
